(() => {
  'use strict';

  const getDialog = (id) => document.getElementById(id);

  const focusDialogItem = (dialog, index) => {
    const item = dialog.querySelector(`[data-rc-usage-dialog-item][data-index="${index}"]`);
    if (!item) return;
    requestAnimationFrame(() => item.scrollIntoView({ block: 'start', behavior: 'auto' }));
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-rc-usage-open]');
    if (opener) {
      const dialog = getDialog(opener.dataset.rcUsageOpen);
      if (!dialog) return;
      const index = Number(opener.dataset.rcUsageIndex || 0);
      dialog.showModal();
      focusDialogItem(dialog, index);
      return;
    }

    const closeButton = event.target.closest('[data-rc-usage-close]');
    if (closeButton) {
      const dialog = closeButton.closest('[data-rc-usage-dialog]');
      if (dialog?.open) dialog.close();
    }
  });

  document.addEventListener('click', (event) => {
    const dialog = event.target.closest('[data-rc-usage-dialog]');
    if (dialog && event.target === dialog && dialog.open) dialog.close();
  });
})();
